/**
 * Created by su0012004  on 2020/8/20.
 */

// import request from '@/components/libs/request'

// class index   {
// }
import Model from '@/components/model/model';
class Index extends Model{
 }



 Index.lists = function(data = {}) {
     let url = '/pc_v1/Index/Index/lists.html';
     return this.get(url, data)
 }



/*
首页聚合数据

// import Index from '@/components/model/index/index'
public function get_all_data(){
*/
 Index.get_all_data = function(data = {}) {
     let url = '/pc_v1/Index/Index/get_all_data.html';
     return this.get(url, data)
 }

    /**
     * GET 请求 无提示
     * ----  @param url 请求URL
     * @param data 请求数据
     * @returns {Promise}
     */
// index.get = function (data){
//   let url = '/api/shangjia_pc_v1/index/index';
//   return this.get(url, data);
// }

export default Index;



// WEBPACK FOOTER //
// ./src/components/model/index/index.js